import { Badge, Card, Flex, Text, ThemeIcon } from "@mantine/core";
import { useHover } from "@mantine/hooks";
import { ProductChoice } from "./product";

type ProductCardProps = ProductChoice & {
  onClick: () => void;
  isSelected: boolean;
};

export const ProductCard = (props: ProductCardProps) => {
  const Icon = props.icon;
  const { hovered, ref } = useHover<HTMLButtonElement>();

  return (
    <Card
      component="button"
      type="button"
      ref={ref}
      withBorder
      onClick={props.onClick}
      w="100%"
      h="100%"
      radius="lg"
      bd={`1.5px solid ${
        hovered ? "var(--mantine-color-brand-3)" : "var(--mantine-color-ink-1)"
      }`}
      style={{
        cursor: "pointer",
        textAlign: "left",
        justifyContent: "flex-start",
      }}
    >
      <ThemeIcon w={40} h={40} c="brand.6" mb="s2" bg="brand.0">
        <Icon size={24} />
      </ThemeIcon>
      <Text fz="h4" fw={600} c="ink.9">
        {props.label}
      </Text>
      <Flex>
        {props.tag && (
          <Badge variant="tag" c="ink.6" bg="ink.0" mr="s1">
            {props.tag}
          </Badge>
        )}
        <Text fz="small" c="ink.5" lh={1.4}>
          {props.description}
        </Text>
      </Flex>
    </Card>
  );
};
